import { faClock } from '@fortawesome/free-solid-svg-icons'
import React, { useCallback } from 'react'
import { Colors } from '../../../../utils/colors/colors'
import { NotificationProps } from '../../FactoryNotification/FactoryNotification'
import GenericNotification from '../GenericNotification'


interface NewOvertimeDeclinedNotificationProps extends NotificationProps{
	item: {
		id: string, 
		notifMsg: string, 
		timestamp: number, 
		viewed: boolean,
		notifData: {
			approved: string, 
			receivedFromType: string, 
            userName: string,
            transactionId: string
		},
	}
}



const NewOvertimeDeclinedNotification = ({ item, clickable, onSetNotificationAsView }: NewOvertimeDeclinedNotificationProps) => {
	const { id, notifMsg, timestamp, viewed, notifData: { approved } } = item

	const touchNotification =  useCallback(
	  () => {
        if(!viewed)
            onSetNotificationAsView(id)
	  },
	  [],
	)
	
	return(
		<GenericNotification 
			touchNotification={touchNotification} 
			

			id={id}
			timestamp={timestamp}
			viewed={clickable ? viewed : true}
			description={"User declined overtime"}
			title={ "Username has declined add overtime to the meet" }

			icon={ faClock }
			color={ Colors.secondaryColor }
		/>
	)
}

export default React.memo( NewOvertimeDeclinedNotification )